import EnhancedAvatar from './EnhancedAvatar';
export default EnhancedAvatar;
//# sourceMappingURL=index.js.map
